var defaultColor = 'transparent';
/**
 * Returns style object that can be used for styling components on focus state.
 * NOTE: the element where this is used needs to have relative positioning so that the
 * pseudo elements created on focus can be properly positioned.
 */

export var getBorderFocusStyles = function getBorderFocusStyles(args) {
  var _ref, _ref2, _ref3, _ref4;

  var sv = args.variables;
  var _args$borderWidth = args.borderWidth,
      borderWidth = _args$borderWidth === void 0 ? sv.borderWidth : _args$borderWidth,
      _args$borderRadius = args.borderRadius,
      borderRadius = _args$borderRadius === void 0 ? sv.borderRadius : _args$borderRadius,
      _args$focusInnerBorde = args.focusInnerBorderColor,
      focusInnerBorderColor = _args$focusInnerBorde === void 0 ? sv.focusInnerBorderColor || defaultColor : _args$focusInnerBorde,
      _args$focusOuterBorde = args.focusOuterBorderColor,
      focusOuterBorderColor = _args$focusOuterBorde === void 0 ? sv.focusOuterBorderColor || defaultColor : _args$focusOuterBorde,
      borderPadding = args.borderPadding;
  var defaultPreudoStyles = {
    content: '""',
    position: 'absolute',
    borderStyle: 'solid',
    pointerEvents: 'none',
    borderWidth: borderWidth,
    borderRadius: borderRadius
  };
  var borderPaddingTop = ((_ref = borderPadding) == null ? void 0 : _ref.top) || borderPadding;
  var borderPaddingBottom = ((_ref2 = borderPadding) == null ? void 0 : _ref2.bottom) || borderPadding;
  var borderPaddingLeft = ((_ref3 = borderPadding) == null ? void 0 : _ref3.left) || borderPadding;
  var borderPaddingRight = ((_ref4 = borderPadding) == null ? void 0 : _ref4.right) || borderPadding;
  return {
    ':focus': {
      outline: 'none'
    },
    ':focus-visible': {
      borderColor: 'transparent',
      ':before': Object.assign({}, defaultPreudoStyles, {
        zIndex: sv.zIndexes.foreground,
        borderColor: focusInnerBorderColor,
        top: borderPadding == null ? '0' : "-" + borderPaddingTop,
        bottom: borderPadding == null ? '0' : "-" + borderPaddingBottom,
        left: borderPadding == null ? '0' : "-" + borderPaddingLeft,
        right: borderPadding == null ? '0' : "-" + borderPaddingRight
      }),
      ':after': Object.assign({}, defaultPreudoStyles, {
        zIndex: sv.zIndexes.foreground,
        borderColor: focusOuterBorderColor,
        top: borderPadding == null ? "-" + borderWidth : "calc(0px - " + borderPaddingTop + " - " + borderWidth + ")",
        bottom: borderPadding == null ? "-" + borderWidth : "calc(0px - " + borderPaddingBottom + " - " + borderWidth + ")",
        left: borderPadding == null ? "-" + borderWidth : "calc(0px - " + borderPaddingLeft + " - " + borderWidth + ")",
        right: borderPadding == null ? "-" + borderWidth : "calc(0px - " + borderPaddingRight + " - " + borderWidth + ")"
      })
    }
  };
};
//# sourceMappingURL=getBorderFocusStyles.js.map
